function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.8259 13.2857C35.348 13.2857 38.1698 10.3186 38.1698 6.64286C38.1698 2.96714 35.348 0 31.8259 0C28.3038 0 25.4607 2.96714 25.4607 6.64286C25.4607 10.3186 28.3038 13.2857 31.8259 13.2857ZM14.8521 13.2857C18.3741 13.2857 21.196 10.3186 21.196 6.64286C21.196 2.96714 18.3741 0 14.8521 0C11.33 0 8.4869 2.96714 8.4869 6.64286C8.4869 10.3186 11.33 13.2857 14.8521 13.2857ZM14.8521 17.7143C9.90846 17.7143 0 20.305 0 25.4643V31H29.7042V25.4643C29.7042 20.305 19.7957 17.7143 14.8521 17.7143ZM31.8259 17.7143C31.2106 17.7143 30.5104 17.7586 29.7678 17.825C32.229 19.685 33.9476 22.1871 33.9476 25.4643V31H46.678V25.4643C46.678 20.305 36.7695 17.7143 31.8259 17.7143Z",
  fill: "#0F0F33"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M34.7046 24.9779V30.9996H51.0008V24.9779C50.6465 20.1605 37.1845 17.3504 29.3906 17.7518C33.2876 20.1605 35.059 23.5728 34.7046 24.9779Z",
  fill: "#C91757"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 31.9836,
  cy: 6.64286,
  rx: 6.91525,
  ry: 6.64286,
  fill: "#C91757"
});

var SvgTeams = function SvgTeams(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 31,
    viewBox: "0 0 51 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTeams, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Teams.e22bf109.svg";
export { ForwardRef as ReactComponent };